<app-abstract-action-confirmation-dialog
  (acceptEvent)="onAcceptClickedHandler()"
  (declineEvent)="onDeclineClickedHandler()"
  [acceptLabel]="data.acceptLabel"
  [cdkFocusInitialOnButtonFlag]="data.cdkFocusInitialOnButtonFlag"
  [declineLabel]="data.declineLabel"
  [formGroup]="formGroup"
  [formInvalidFlag]="formGroup.invalid"
  [messageLine1]="data.messageLine1"
  [messageLine2]="data.messageLine2"
  [subMessageLine1]="data.subMessageLine1"
  [subMessageLine2]="data.subMessageLine2"
>
  <div class="form" popup-form>
    <form [formGroup]="formGroup">
      <mat-form-field class="number-dialog whole-width">
        <mat-label>{{ data.numberMatLabel }}</mat-label>
        <input autocomplete="off" formControlName="numberValue" matInput required type="number" />
        @if (formGroup.controls.numberValue.hasError('required')) {
          <mat-error>{{ data.numberRequiredErrorLabel }}.</mat-error>
        }
        @if (formGroup.controls.numberValue.hasError('min')) {
          <mat-error>Doit être supérieur.</mat-error>
        }
        @if (formGroup.controls.numberValue.hasError('max')) {
          <mat-error>Doit être inférieur.</mat-error>
        }
        @if (formGroup.controls.numberValue.hasError('pattern')) {
          <mat-error>{{ data.numberPatternErrorLabel }}.</mat-error>
        }
      </mat-form-field>
    </form>
  </div>
</app-abstract-action-confirmation-dialog>
